import angular from "angular";
import { moduleName as recordModule } from "../../../../records";
import { vsModuleName as lookupModuleName } from "../../../../records/lookup/module";
import { TypeOfAgreementConfig } from "./../../../../Contract/shared/lookup/typeOfAgreement";
import { PerformanceGuaranteeConfig } from "./../../../../Contract/shared/lookup/performanceGuaranteeType";
import { PerformanceGuaranteePartsConfig } from "./../../../../Contract/shared/lookup/performanceGuaranteePartsType";
import { FeeStructureTypeConfig } from "./../../../../Contract/shared/lookup/feeStructureType";
import { FeeStructureConfig } from "./feeStructure";
import { CostTypeConfig } from "./../../../../Contract/shared/lookup/costType";
import { GamingContractConfig } from "./gamingContract";
import { GamingContractMasterAgreementConfig } from "./gamingContractMasterAgreement";
import { vsModuleName as sharedContractModuleName } from "../../../../Contract/shared";
import { PaymentTermConfig } from "./../../../../Contract/shared/lookup/paymentTerm";
import { GamingContractLineItemConfig } from "./gamingContractLineItem";
import { GamingContractMasterAgreementAmendmentConfig } from "./gamingContractMasterAgreementAmendment";

export const vsModuleName = "SlotTrak.CacheCreek.Configuration";

const module = angular
  .module(vsModuleName, [
    recordModule,
    lookupModuleName,
    sharedContractModuleName,
  ])
  .config(TypeOfAgreementConfig)
  .config(PerformanceGuaranteeConfig)
  .config(PerformanceGuaranteePartsConfig)
  .config(FeeStructureConfig)
  .config(FeeStructureTypeConfig)
  .config(CostTypeConfig)
  .config(PaymentTermConfig)
  .config(GamingContractConfig)
  .config(GamingContractLineItemConfig)
  .config(GamingContractMasterAgreementConfig)
  .config(GamingContractMasterAgreementAmendmentConfig);
